<template>
    <div>
        <div class="is-flex justify-content-center align-items-center py-4">
            <div>{{ i18n.mesacne }}</div>
            <div class="toggleWrapper">
                <input type="checkbox" v-model="priceToggle" class="mobileToggle" id="price-toggle">
                <label for="price-toggle"></label>
            </div>
            <div>
              {{ i18n.rocne }}
            </div>
            <div class="registration-pricing--discount">
              {{ i18n.zlava_25 }}
            </div>
        </div>
        <div class="registration-pricing registration-pricing--mobile">
            <div class="registration-pricing--block">
                <div class="registration-pricing--head" @click="activeAccordion = 1;">
                    <h3 class="registration-pricing--title">{{ i18n.rodinny_klub }} <span class="material-icons"><template
                        v-if="activeAccordion === 1">expand_less</template><template
                        v-else>expand_more</template></span>
                    </h3>
                    <p class="registration-pricing--subtitle">{{ i18n.virtualne_mini_clenstvo }}</p>
                    <p class="registration-pricing--price"><span v-if="!priceToggle">{{Intl.NumberFormat('sk-SK', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(pricing.family.monthly_price) }}</span><span v-else>{{Intl.NumberFormat('sk-SK', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(pricing.family.yearly_price) }}</span>
                        {{ i18n.eur_lomeno_mes }}</p>
                </div>
                <div class="registration-pricing--body" :class="{'active': activeAccordion === 1}">
                    <div class="columns is-multiline is-mobile">
                        <div class="column is-7 registration-pricing--border">
                            <p><b>{{ i18n.pristup_do_akademie }}</b></p>
                        </div>
                        <div class="column is-5 registration-pricing--border">
                            <p class="has-text-centered registration-pricing--badge"><span class="material-icons">verified</span>
                            </p>
                        </div>
                        <div class="column is-7 registration-pricing--border">
                            <p><b>{{ i18n.testovanie }}</b></p>
                        </div>
                        <div class="column is-5 registration-pricing--border">
                            <p class="has-text-centered registration-pricing--badge"><span class="material-icons">verified</span>
                            </p>
                        </div>
                        <div class="column is-7 registration-pricing--border">
                            <p><b>{{ i18n.sledovanie_pokroku }}</b></p>
                        </div>
                        <div class="column is-5 registration-pricing--border">
                            <p class="has-text-centered registration-pricing--badge"><span class="material-icons">verified</span>
                            </p>
                        </div>
                        <div class="column is-7 registration-pricing--border">
                            <p><b>{{ i18n.sprava_clenov }}</b></p>
                        </div>
                        <div class="column is-5 registration-pricing--border">
                            <p class="has-text-centered registration-pricing--badge"><span class="material-icons">verified</span>
                            </p>
                        </div>
                        <div class="column is-7 registration-pricing--border">
                            <p><b>{{ i18n.stromacik_mini_pdf }}</b></p>
                        </div>
                        <div class="column is-5 registration-pricing--border">
                            <p class="has-text-centered registration-pricing--badge"><span class="material-icons">verified</span>
                            </p>
                        </div>
                        <div class="column is-7 registration-pricing--border">
                            <p><b>{{ i18n.limit_clenov }}</b></p>
                        </div>
                        <div class="column is-5 registration-pricing--border">
                            <p class="has-text-centered">{{pricing.family.limit}}</p>
                        </div>
                        <template v-if="catalog === 'stromSK'">
							<div class="column is-7">
								<p><b>{{ i18n.ucast_na_seminaroch_title }}</b></p>
							</div>
							<div class="column is-5">
								<p class="has-text-centered">+ {{Intl.NumberFormat('sk-SK', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(pricing.seminar.price) }}  {{ i18n.eur_lomeno_mes }}</p>
							</div>
						</template>
                        <div class="column is-full has-text-centered">
                            <a :href="familyRegistrationRoute +'?pricing=' + (priceToggle ? 'yearly'  : 'monthly')" class="button">
                                <span>{{ i18n.registracia_text }}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="registration-pricing--block">
                <div class="registration-pricing--head" @click="activeAccordion = 2;">
                    <h3 class="registration-pricing--title">{{ i18n.rodinny_klub_plus_text }} <span class="material-icons"><template
                        v-if="activeAccordion === 2">expand_less</template><template
                        v-else>expand_more</template></span></h3>
                    <p class="registration-pricing--subtitle">Základné rodinné členstvo</p>
                    <p class="registration-pricing--price"><span v-if="!priceToggle">{{Intl.NumberFormat('sk-SK', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(pricing.family_plus.monthly_price) }}</span><span v-else>{{Intl.NumberFormat('sk-SK', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(pricing.family_plus.yearly_price) }}</span>{{ i18n.eur_lomeno_mesacne }}</p>
                </div>
                <div class="registration-pricing--body" :class="{'active': activeAccordion === 2}">
                    <div class="columns is-multiline is-mobile">
                        <div class="column is-7 registration-pricing--border">
                            <p><b>{{ i18n.pristup_do_akademie }}</b></p>
                        </div>
                        <div class="column is-5 registration-pricing--border">
                            <p class="has-text-centered registration-pricing--badge"><span class="material-icons">verified</span>
                            </p>
                        </div>
                        <div class="column is-7 registration-pricing--border">
                            <p><b>{{ i18n.testovanie }}</b></p>
                        </div>
                        <div class="column is-5 registration-pricing--border">
                            <p class="has-text-centered registration-pricing--badge"><span class="material-icons">verified</span>
                            </p>
                        </div>
                        <div class="column is-7 registration-pricing--border">
                            <p><b>{{ i18n.sledovanie_pokroku }}</b></p>
                        </div>
                        <div class="column is-5 registration-pricing--border">
                            <p class="has-text-centered registration-pricing--badge"><span class="material-icons">verified</span>
                            </p>
                        </div>
                        <div class="column is-7 registration-pricing--border">
                            <p><b>{{ i18n.sprava_clenov }}</b></p>
                        </div>
                        <div class="column is-5 registration-pricing--border">
                            <p class="has-text-centered registration-pricing--badge"><span class="material-icons">verified</span>
                            </p>
                        </div>
                        <div class="column is-7 registration-pricing--border">
                            <p><b>{{ i18n.stromacik_mini_pdf }}</b></p>
                        </div>
                        <div class="column is-5 registration-pricing--border">
                            <p class="has-text-centered registration-pricing--badge"><span class="material-icons">verified</span>
                            </p>
                        </div>
                        <div class="column is-7 registration-pricing--border">
                            <p><b>{{ i18n.stromacik_mini_tlacena_verzia }}</b></p>
                        </div>
                        <div class="column is-5 registration-pricing--border">
                            <p class="has-text-centered registration-pricing--badge"><span class="material-icons">verified</span>
                            </p>
                        </div>
                        <template v-if="catalog === 'stromSK'">
							<div class="column is-7 registration-pricing--border">
								<p><b>{{ i18n.zlava_na_pomocky }}</b></p>
							</div>
							<div class="column is-5 registration-pricing--border">
								<p class="has-text-centered registration-pricing--badge"><span class="material-icons">verified</span>
								</p>
							</div>
						</template>

                        <div class="column is-7 registration-pricing--border">
                            <p><b>{{ i18n.limit_clenov }}</b></p>
                        </div>
                        <div class="column is-5 registration-pricing--border">
                            <p class="has-text-centered">{{pricing.family_plus.limit}}</p>
                        </div>
                        <template v-if="catalog === 'stromSK'">
							<div v-if="catalog === 'stromSK'" class="column is-7">
								<p><b>{{ i18n.ucast_na_seminaroch_title }}</b></p>
							</div>
							<div class="column is-5">
								<p class="has-text-centered">+ {{Intl.NumberFormat('sk-SK', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(pricing.seminar.price) }} {{ i18n.eur_lomeno_mes }}</p>
							</div>
						</template>
                        <div class="column is-full has-text-centered">
                            <a :href="familyRegistrationRoute + '/plus?pricing=' + (priceToggle ? 'yearly'  : 'monthly')" class="button">
                                <span>{{ i18n.registracia_text }}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="registration-pricing--block">
                <div class="registration-pricing--head" @click="activeAccordion = 3;">
                    <h3 class="registration-pricing--title">{{ i18n.triendy_klub }} <span class="material-icons"><template
                        v-if="activeAccordion === 3">expand_less</template><template
                        v-else>expand_more</template></span>
                    </h3>
                    <p class="registration-pricing--subtitle">{{ i18n.zakladne_clenstvo }}</p>
                    <p class="registration-pricing--price"><span v-if="!priceToggle">{{Intl.NumberFormat('sk-SK', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(pricing.club.monthly_price) }}</span><span v-else>{{Intl.NumberFormat('sk-SK', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(pricing.club.yearly_price) }}</span>
                      {{ i18n.eur_lomeno_mesacne }}</p>
                </div>
                <div class="registration-pricing--body" :class="{'active': activeAccordion === 3}">
                    <div class="columns is-multiline is-mobile">
                        <div class="column is-7 registration-pricing--border">
                            <p><b>{{ i18n.pristup_do_akademie }}</b></p>
                        </div>
                        <div class="column is-5 registration-pricing--border">
                            <p class="has-text-centered registration-pricing--badge"><span class="material-icons">verified</span>
                            </p>
                        </div>
                        <div class="column is-7 registration-pricing--border">
                            <p><b>{{ i18n.testovanie }}</b></p>
                        </div>
                        <div class="column is-5 registration-pricing--border">
                            <p class="has-text-centered registration-pricing--badge"><span class="material-icons">verified</span>
                            </p>
                        </div>
                        <div class="column is-7 registration-pricing--border">
                            <p><b>{{ i18n.sledovanie_pokroku }}</b></p>
                        </div>
                        <div class="column is-5 registration-pricing--border">
                            <p class="has-text-centered registration-pricing--badge"><span class="material-icons">verified</span>
                            </p>
                        </div>
                        <div class="column is-7 registration-pricing--border">
                            <p><b>{{ i18n.sprava_clenov }}</b></p>
                        </div>
                        <div class="column is-5 registration-pricing--border">
                            <p class="has-text-centered registration-pricing--badge"><span class="material-icons">verified</span>
                            </p>
                        </div>
                        <div class="column is-7 registration-pricing--border">
                            <p><b>{{ i18n.stromacik_mini_pdf }}</b></p>
                        </div>
                        <div class="column is-5 registration-pricing--border">
                            <p class="has-text-centered registration-pricing--badge"><span class="material-icons">verified</span>
                            </p>
                        </div>
                        <div class="column is-7 registration-pricing--border">
                            <p><b>{{ i18n.stromacik_mini_tlacena_verzia }}</b></p>
                        </div>
                        <div class="column is-5 registration-pricing--border">
                            <p class="has-text-centered registration-pricing--badge"><span class="material-icons">verified</span>
                            </p>
                        </div>
                        <div class="column is-7 registration-pricing--border">
                            <p><b>{{ i18n.limit_clenov }}</b></p>
                        </div>
                        <div class="column is-5 registration-pricing--border">
                            <p class="has-text-centered">{{pricing.club.limit}}</p>
                        </div>
                        <template v-if="catalog === 'stromSK'">
							<div class="column is-7">
								<p><b>{{ i18n.ucast_na_seminaroch_title }}</b></p>
							</div>
							<div class="column is-5">
								<p class="has-text-centered">+ {{Intl.NumberFormat('sk-SK', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(pricing.seminar.price) }} {{ i18n.eur_lomeno_mes }}</p>
							</div>
						</template>
                        <div class="column is-full has-text-centered">
                            <a :href="schoolRegistrationRoute + '/plus?pricing=' + (priceToggle ? 'yearly'  : 'monthly')" class="button">
                                <span>{{ i18n.registracia_text }}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="registration-pricing--block">
                <div class="registration-pricing--head" @click="activeAccordion = 4;">
                    <h3 class="registration-pricing--title">{{ i18n.triedny_klub_plus_text }} <span class="material-icons"><template
                        v-if="activeAccordion === 4">expand_less</template><template
                        v-else>expand_more</template></span></h3>
                    <p class="registration-pricing--subtitle">{{ i18n.premiove_clenstvo }}</p>
                    <p class="registration-pricing--price"><span v-if="!priceToggle">{{Intl.NumberFormat('sk-SK', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(pricing.club_plus.monthly_price) }}</span><span
                        v-else>{{Intl.NumberFormat('sk-SK', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(pricing.club_plus.yearly_price) }}</span> {{ i18n.eur_lomeno_mesacne }}</p>
                </div>
                <div class="registration-pricing--body" :class="{'active': activeAccordion === 4}">
                    <div class="columns is-multiline is-mobile">
                        <div class="column is-7 registration-pricing--border">
                            <p><b>{{ i18n.pristup_do_akademie }}</b></p>
                        </div>
                        <div class="column is-5 registration-pricing--border">
                            <p class="has-text-centered registration-pricing--badge"><span class="material-icons">verified</span>
                            </p>
                        </div>
                        <div class="column is-7 registration-pricing--border">
                            <p><b>{{ i18n.testovanie }}</b></p>
                        </div>
                        <div class="column is-5 registration-pricing--border">
                            <p class="has-text-centered registration-pricing--badge"><span class="material-icons">verified</span>
                            </p>
                        </div>
                        <div class="column is-7 registration-pricing--border">
                            <p><b>{{ i18n.sledovanie_pokroku }}</b></p>
                        </div>
                        <div class="column is-5 registration-pricing--border">
                            <p class="has-text-centered registration-pricing--badge"><span class="material-icons">verified</span>
                            </p>
                        </div>
                        <div class="column is-7 registration-pricing--border">
                            <p><b>{{ i18n.sprava_clenov }}</b></p>
                        </div>
                        <div class="column is-5 registration-pricing--border">
                            <p class="has-text-centered registration-pricing--badge"><span class="material-icons">verified</span>
                            </p>
                        </div>
                        <div class="column is-7 registration-pricing--border">
                            <p><b>{{ i18n.stromacik_mini_pdf }}</b></p>
                        </div>
                        <div class="column is-5 registration-pricing--border">
                            <p class="has-text-centered registration-pricing--badge"><span class="material-icons">verified</span>
                            </p>
                        </div>
                        <div class="column is-7 registration-pricing--border">
                            <p><b>{{ i18n.stromacik_mini_tlacena_verzia }}</b></p>
                        </div>
                        <div class="column is-5 registration-pricing--border">
                            <p class="has-text-centered registration-pricing--badge"><span class="material-icons">verified</span>
                            </p>
                        </div>
                        <div class="column is-7 registration-pricing--border">
                            <p><b>{{ i18n.limit_clenov }}</b></p>
                        </div>
                        <div class="column is-5 registration-pricing--border">
                            <p class="has-text-centered">{{pricing.club_plus.limit}}</p>
                        </div>
                        <template v-if="catalog === 'stromSK'">
							<div class="column is-7">
								<p><b>{{ i18n.ucast_na_seminaroch_title }}</b></p>
							</div>
							<div class="column is-5">
								<p class="has-text-centered registration-pricing--badge"><span class="material-icons">verified</span>
								</p>
							</div>
						</template>
                        <div class="column is-full has-text-centered">
                            <a :href="schoolRegistrationRoute + '/plus?pricing=' + (priceToggle ? 'yearly'  : 'monthly')" class="button">
                                <span>{{ i18n.registracia_text }}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="registration-pricing">
            <div class="columns is-multiline is-mobile">
                <div
                    class="column is-one-fifth-tablet is-full-mobile registration-pricing--sticky">

                </div>
                <div class="column is-one-fifth-tablet is-one-quarter-mobile registration-pricing--sticky">
                    <h3 class="registration-pricing--title">{{ i18n.rodinny_klub }}</h3>
                    <p class="registration-pricing--subtitle">{{ i18n.virtualne_mini_clenstvo }}</p>
                    <p class="has-text-centered registration-pricing--price"><span v-if="!priceToggle">{{Intl.NumberFormat('sk-SK', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(pricing.family.monthly_price) }}</span><span v-else>{{Intl.NumberFormat('sk-SK', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(pricing.family.yearly_price) }}</span>
                      {{ i18n.eur_lomeno_mesacne }}</p>
                </div>
                <div class="column is-one-fifth-tablet is-one-quarter-mobile registration-pricing--sticky">
                    <h3 class="registration-pricing--title">{{ i18n.rodinny_klub_plus_text }}</h3>
                    <p class="registration-pricing--subtitle">{{ i18n.zakladne_rodinne_clensto }}</p>
                    <p class="has-text-centered registration-pricing--price"><span v-if="!priceToggle">{{Intl.NumberFormat('sk-SK', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(pricing.family_plus.monthly_price) }}</span><span v-else>{{Intl.NumberFormat('sk-SK', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(pricing.family_plus.yearly_price) }}</span>
                      {{ i18n.eur_lomeno_mesacne }}</p>
                </div>
                <div class="column is-one-fifth-tablet is-one-quarter-mobile registration-pricing--sticky">
                    <h3 class="registration-pricing--title">{{ i18n.triendy_klub }}</h3>
                    <p class="registration-pricing--subtitle">{{ i18n.zakladne_clenstvo }}</p>
                    <p class="has-text-centered registration-pricing--price"><span v-if="!priceToggle">{{Intl.NumberFormat('sk-SK', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(pricing.club.monthly_price) }}</span><span v-else>{{Intl.NumberFormat('sk-SK', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(pricing.club.yearly_price) }}</span>
                      {{ i18n.eur_lomeno_mesacne }}</p>
                </div>
                <div class="column is-one-fifth-tablet is-one-quarter-mobile registration-pricing--sticky">
                    <h3 class="registration-pricing--title">{{ i18n.triedny_klub_plus_text }}</h3>
                    <p class="registration-pricing--subtitle">{{ i18n.premiove_clenstvo }}</p>
                    <p class="has-text-centered registration-pricing--price"><span v-if="!priceToggle">{{Intl.NumberFormat('sk-SK', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(pricing.club_plus.monthly_price) }}</span><span
                        v-else>{{Intl.NumberFormat('sk-SK', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(pricing.club_plus.yearly_price) }}</span> {{ i18n.eur_lomeno_mesacne }}</p>
                </div>
                <div
                    class="column registration-pricing--border is-one-fifth-tablet is-full-mobile has-text-left-desktop has-text-centered-tablet has-text-centered-mobile">
                    <p><b>{{ i18n.pristup_do_akademie }}</b></p>
                </div>
                <div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
                    <p class="has-text-centered registration-pricing--badge"><span
                        class="material-icons">verified</span></p>
                </div>
                <div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
                    <p class="has-text-centered registration-pricing--badge"><span
                        class="material-icons">verified</span></p>
                </div>
                <div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
                    <p class="has-text-centered registration-pricing--badge"><span
                        class="material-icons">verified</span></p>
                </div>
                <div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
                    <p class="has-text-centered registration-pricing--badge"><span
                        class="material-icons">verified</span></p>
                </div>
                <div
                    class="column registration-pricing--border is-one-fifth-tablet is-full-mobile has-text-left-desktop has-text-centered-tablet has-text-centered-mobile is-vcentered">
                    <p><b>{{ i18n.testovanie }}</b></p>
                </div>
                <div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
                    <p class="has-text-centered registration-pricing--badge"><span
                        class="material-icons">verified</span></p>
                </div>
                <div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
                    <p class="has-text-centered registration-pricing--badge"><span
                        class="material-icons">verified</span></p>
                </div>
                <div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
                    <p class="has-text-centered registration-pricing--badge"><span
                        class="material-icons">verified</span></p>
                </div>
                <div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
                    <p class="has-text-centered registration-pricing--badge"><span
                        class="material-icons">verified</span></p>
                </div>
                <div
                    class="column registration-pricing--border is-one-fifth-tablet is-full-mobile has-text-left-desktop has-text-centered-tablet has-text-centered-mobile">
                    <p><b>{{ i18n.sledovanie_pokroku }}</b></p>
                </div>
                <div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
                    <p class="has-text-centered registration-pricing--badge"><span
                        class="material-icons">verified</span></p>
                </div>
                <div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
                    <p class="has-text-centered registration-pricing--badge"><span
                        class="material-icons">verified</span></p>
                </div>
                <div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
                    <p class="has-text-centered registration-pricing--badge"><span
                        class="material-icons">verified</span></p>
                </div>
                <div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
                    <p class="has-text-centered registration-pricing--badge"><span
                        class="material-icons">verified</span></p>
                </div>
                <div
                    class="column registration-pricing--border is-one-fifth-tablet is-full-mobile has-text-left-desktop has-text-centered-tablet has-text-centered-mobile">
                    <p><b>{{ i18n.sprava_clenov }}</b></p>
                </div>
                <div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
                    <p class="has-text-centered registration-pricing--badge"><span
                        class="material-icons">verified</span></p>
                </div>
                <div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
                    <p class="has-text-centered registration-pricing--badge"><span
                        class="material-icons">verified</span></p>
                </div>
                <div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
                    <p class="has-text-centered registration-pricing--badge"><span
                        class="material-icons">verified</span></p>
                </div>
                <div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
                    <p class="has-text-centered registration-pricing--badge"><span
                        class="material-icons">verified</span></p>
                </div>
                <div
                    class="column registration-pricing--border is-one-fifth-tablet is-full-mobile has-text-left-desktop has-text-centered-tablet has-text-centered-mobile">
                    <p><b>{{ i18n.stromacik_mini_pdf }}</b></p>
                </div>
                <div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
                    <p class="has-text-centered registration-pricing--badge"><span
                        class="material-icons">verified</span></p>
                </div>
                <div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
                    <p class="has-text-centered registration-pricing--badge"><span
                        class="material-icons">verified</span></p>
                </div>
                <div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
                    <p class="has-text-centered registration-pricing--badge"><span
                        class="material-icons">verified</span></p>
                </div>
                <div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
                    <p class="has-text-centered registration-pricing--badge"><span
                        class="material-icons">verified</span></p>
                </div>
                <div
                    class="column registration-pricing--border is-one-fifth-tablet is-full-mobile has-text-left-desktop has-text-centered-tablet has-text-centered-mobile">
                    <p><b>{{ i18n.stromacik_mini_tlacena_verzia }}</b></p>
                </div>
                <div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
                    <p class="has-text-centered"><span class="material-icons">minimize</span></p>
                </div>
                <div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
                    <p class="has-text-centered registration-pricing--badge"><span
                        class="material-icons">verified</span></p>
                </div>
                <div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
                    <p class="has-text-centered registration-pricing--badge"><span
                        class="material-icons">verified</span></p>
                </div>
                <div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
                    <p class="has-text-centered registration-pricing--badge"><span
                        class="material-icons">verified</span></p>
                </div>
                <template v-if="catalog === 'stromSK'">
					<div
						class="column registration-pricing--border is-one-fifth-tablet is-full-mobile has-text-left-desktop has-text-centered-tablet has-text-centered-mobile">
						<p><b>{{ i18n.zlava_na_pomocky }}</b></p>
					</div>
					<div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
						<p class="has-text-centered"><span class="material-icons">minimize</span></p>
					</div>
					<div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
						<p class="has-text-centered registration-pricing--badge"><span
							class="material-icons">verified</span></p>
					</div>
					<div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
						<p class="has-text-centered"><span class="material-icons">minimize</span></p>
					</div>
					<div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
						<p class="has-text-centered"><span class="material-icons">minimize</span></p>
					</div>
				</template>
                <div
                    class="column registration-pricing--border is-one-fifth-tablet is-full-mobile has-text-left-desktop has-text-centered-tablet has-text-centered-mobile">
                    <p><b>{{ i18n.limit_clenov }}</b></p>
                </div>
                <div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
                    <p class="has-text-centered">{{pricing.family.limit}}</p>
                </div>
                <div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
                    <p class="has-text-centered">{{pricing.family_plus.limit}}</p>
                </div>
                <div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
                    <p class="has-text-centered">{{pricing.club.limit}}</p>
                </div>
                <div class="column registration-pricing--border is-one-fifth-tablet is-one-quarter-mobile">
                    <p class="has-text-centered">{{pricing.club_plus.limit}}</p>
                </div>
                <template v-if="catalog === 'stromSK'">
					<div
						class="column  is-one-fifth-tablet is-full-mobile has-text-left-desktop has-text-centered-tablet has-text-centered-mobile">
						<p><b>{{ i18n.ucast_na_seminaroch_title }}</b></p>
					</div>
					<div class="column  is-one-fifth-tablet is-one-quarter-mobile">
						<p class="has-text-centered">+ {{Intl.NumberFormat('sk-SK', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(pricing.seminar.price) }} {{ i18n.eur_lomeno_mes }}</p>
					</div>
					<div class="column  is-one-fifth-tablet is-one-quarter-mobile">
						<p class="has-text-centered">+ {{Intl.NumberFormat('sk-SK', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(pricing.seminar.price) }} {{ i18n.eur_lomeno_mes }}</p>
					</div>
					<div class="column  is-one-fifth-tablet is-one-quarter-mobile">
						<p class="has-text-centered">+ {{Intl.NumberFormat('sk-SK', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(pricing.seminar.price) }} {{ i18n.eur_lomeno_mes }}</p>
					</div>
					<div class="column  is-one-fifth-tablet is-one-quarter-mobile">
						<p class="has-text-centered registration-pricing--badge"><span
							class="material-icons">verified</span></p>
					</div>
				</template>
                <div
                    class="column is-one-fifth-tablet is-full-mobile has-text-left-desktop has-text-centered-tablet has-text-centered-mobile">

                </div>
                <div class="column is-one-fifth-tablet is-one-quarter-mobile">
                    <div class="has-text-centered">
                        <a :href="familyRegistrationRoute + '?pricing=' + (priceToggle ? 'yearly' : 'monthly')"
                           class="button">
                            <span>{{ i18n.registracia_text }}</span>
                        </a>
                    </div>
                </div>
                <div class="column is-one-fifth-tablet is-one-quarter-mobile">
                    <div class="has-text-centered">
                        <a :href="familyRegistrationRoute + '/plus?pricing=' + (priceToggle ? 'yearly'  : 'monthly')"
                           class="button">
                            <span>{{ i18n.registracia_text }}</span>
                        </a>
                    </div>
                </div>
                <div class="column is-one-fifth-tablet is-one-quarter-mobile">
                    <div class="has-text-centered">
                        <a :href="schoolRegistrationRoute + '?pricing=' + (priceToggle ? 'yearly'  : 'monthly')"
                           class="button">
                            <span>{{ i18n.registracia_text }}</span>
                        </a>
                    </div>
                </div>
                <div class="column is-one-fifth-tablet is-one-quarter-mobile">
                    <div class="has-text-centered">
                        <a :href="schoolRegistrationRoute +  '/plus?pricing=' + (priceToggle ? 'yearly'  : 'monthly')"
                           class="button">
                            <span>{{ i18n.registracia_text }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "RegistrationPricing",
    props: {
        pricing: Object,
        schoolRegistrationRoute: String,
        familyRegistrationRoute: String,
		catalog: String
    },
    data: function () {
        return {
            activeAccordion: 1,
            priceToggle: true,
            i18n: i18n
        }
    }
}
</script>

<style scoped>

</style>
